import {HubOutlined as TraceIcon} from "@mui/icons-material";
import React, {useEffect} from "react";
import parkourImage from "../../assets/ParkourLogo.svg";
import css_self from "./css/NavBar.module.scss";
import "./css/NavBar.scss";
import {Tooltip, Avatar, Box, Button, IconButton, Menu, MenuItem, Popover, Typography, Link} from "@mui/material";
import {Blue3, Grey2, Grey17, Grey6, White, Grey5, Grey4, Blue4} from "../../theme/styles";
import {buildPositionTree} from "./positionTree";
import PositionTreeGuides, {ROW_PADDING} from "./PositionTreeGuides";
import {useNavigate} from "react-router";
import {AccountTreeOutlined, ArticleOutlined, CodeOutlined, DatasetOutlined, HelpOutlineOutlined, InsightsOutlined, Language, LockResetOutlined, Logout, MedicalServicesOutlined, PermIdentity, Settings, SettingsOutlined, SupervisorAccount, SwitchAccount as SwitchAccountIcon, Sync, SyncAlt, ThumbUp, VerifiedOutlined, WorkOutlined as WorkOutline} from "@mui/icons-material";
import useAppContext from "../../util/AppContext";
import EventBus from "../../util/EventBus";
import {Account, SessionContext, hasProduct} from "../../util/SessionContext";
import css_buttons from "../Common/css/CCButton.module.scss";
import axios from "axios";
import {SwitchAccount} from "../Login2/SwitchAccount";
import Login2 from "../Login2/Login2";
import {buildSsoHandoffUrl, handoffVisibility} from "../../util/ssoAuthenticate";
import {useMqttClient} from "../../util/MqttClient";
import NotificationBell from "../Notifications/NotificationBell";
import AssistantChat from "../Assistant/AssistantChat";
import ChangePasswordDialog from "../Login2/ChangePasswordDialog";

// THE MQTT PROBE DOT IS A TEST INSTRUMENT, NOT A PRODUCT FEATURE (Ed, 2026-10-29: "Make the dot on the
// NavBar only visible in the environment is not prod. Do this in all applications."). It is drawn
// only when the build's environment is not prod; the probe itself still runs, so the data attributes
// the smoke checks read are unaffected where the dot is drawn.
const SHOW_PROBE_DOT = process.env.REACT_APP_CRES_ENV !== "prod";

type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement}


export default function NavBar() {
    const navigate = useNavigate();
    const [showLoginDialog, setShowLoginDialog] = React.useState<boolean>(false);
    const [showSwitchAccount, setShowSwitchAccount] = React.useState<boolean>(false);
    const [showChangePassword, setShowChangePassword] = React.useState<boolean>(false);
    const [, setCanAccessAdministration] = React.useState<boolean>(false);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const sessionContext:SessionContext = useAppContext()?.sessionContext!;

    // useMqttClient subscribes to global + per-user topics on connect and
    // tracks how many probe-tagged messages (kind === MQTT_PROBE_KIND, sent
    // by cres-aws-t1/scripts/mqtt/test-mqtt-echo.py) have been received.
    // Containers that need to listen to other topics attach their own
    // `client.on("message", ...)` and can `client.subscribe(<filter>)` for
    // additional dynamic topics; the IoT custom authorizer policy permits
    // any filter under `cres_web_t1/v1/*`.
    const {client: mqttClient, received: mqttReceived, notificationSignal} = useMqttClient(sessionContext);

    // Brief visual ping when a PROBE message arrives. Production traffic
    // (notifications, sync events) does NOT trigger this — only payloads
    // carrying `kind: "cres-mqtt-echo-probe"` do.
    const [mqttPing, setMqttPing] = React.useState<boolean>(false);
    useEffect(() => {
        if (mqttReceived.probeCount === 0) return;
        setMqttPing(true);
        const id = setTimeout(() => setMqttPing(false), 700);
        return () => clearTimeout(id);
    }, [mqttReceived.probeCount]);

    useEffect(() => {
        const sessionUpdateListener = () => {
            // @ts-ignore
            if (sessionContext.getPrivileges() && sessionContext.getPrivileges().length > 0) {
                let privilege = sessionContext.getPrivileges().find((p: string) => p === "Administrator");
                if (privilege) setCanAccessAdministration(true)
            }
            // A valid session means the login pane has done its job, so close it on VALIDITY rather
            // than only on the explicit setShowLoginDialog(false) that login() runs as its last step.
            // Without this, anything going wrong part-way through that sequence leaves the pane
            // sitting on top of an app the user is already signed in to.
            //
            // Safe against the switch-account flow: the button that opens this pane only renders
            // while the session is INVALID (a valid session shows the avatar instead), and switching
            // accounts uses the separate SwitchAccount component.
            if (sessionContext.valid()) {
                setShowLoginDialog(false);
            } else if (sessionContext.getShowLoginDialog()) {
                setShowLoginDialog(true);
            } else {
                setShowLoginDialog(false);
            }
        };

        if (mqttClient) {
            mqttClient.on("message", function (topic: any, payload: any) {
                console.log(`received mqtt message on topic '${topic}' -- ${payload}`);
            });
        }

       // @ts-ignore
        EventBus.session.addListener("update", sessionUpdateListener);
        EventBus.components.addListener("switch-account-close", onSwitchAccountClose)
        sessionUpdateListener();

       // @ts-ignore
        return () => {
            EventBus.session.removeListener("update", sessionUpdateListener);
            EventBus.components.removeListener("switch-account-close", onSwitchAccountClose);
        }
    }, [sessionContext, mqttClient]);

    let content = (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingLeft: 20, height: "50px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Grey2, backgroundColor: White}}>
                <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start",
                              minWidth: 0 }}>
                    <div style={{ paddingTop: "0px", paddingRight: "2px", marginLeft: "-5px", cursor: "pointer" }} onClick={() => navigate("/home")}>
                        <img className={css_self.ParkourLogo} src={parkourImage} alt="Home" />
                    </div>
                    <div style={{ paddingTop: "5px", marginLeft: "57px", marginRight: "4px" }}>
                        <Typography style={{ fontSize: 24, fontWeight: 400, color: Grey4 }}>|</Typography>
                    </div>
                    <Box sx={{ paddingTop: "7px", cursor: "pointer",
                              display: { xs: "none", sm: "block" } }} onClick={() => navigate("/home")}>
                        <Typography style={{ fontSize: 24, fontWeight: 500, color: Blue4 }}>
                            &nbsp;&nbsp;ParkourAI
                        </Typography>
                    </Box>
                    <Box sx={{ paddingTop: "5px", marginLeft: "15px", marginRight: "4px",
                               display: { xs: "none", sm: "block" } }}>
                        <Typography style={{ fontSize: 24, fontWeight: 400, color: Grey4 }}>|</Typography>
                    </Box>
                    <div style={{ paddingTop: "7px", cursor: "pointer" }} onClick={() => navigate("/home")}>
                        <Typography style={{ fontSize: 24, fontWeight: 400, color: Blue3 }}>
                            &nbsp;&nbsp;QMS
                        </Typography>
                    </div>
                </div>
                </div>
                <div key={2} style={{display: "flex", flexDirection: "row", justifyContent: "center", flexGrow: 1, paddingTop: "15px", marginLeft: "30px"}}>
                    {sessionContext.valid() ? (
                        <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey5}}>Welcome: <b>{sessionContext.getAccountName()}!</b></Typography>
                        ) : null}
                </div>
                <Box key={3} sx={{display: "flex", flexDirection: "row", justifyContent: "flex-end", minWidth: { xs: 0, sm: "260px" }, paddingTop: "4px"}}>
                    {sessionContext.valid() && SHOW_PROBE_DOT && (() => {
                        // Probe-only indicator. Gray at rest; turns green on
                        // first probe receipt. The dot itself does not
                        // reflect connection status — connect churn would
                        // make it look noisy and obscure the test signal.
                        const everReceived = mqttReceived.probeCount > 0;
                        const dotColor = everReceived ? "#27AE60" : Grey5;
                        const tooltip = everReceived
                            ? `MQTT probes received: ${mqttReceived.probeCount}` +
                              (mqttReceived.lastTopic ? ` • last: ${mqttReceived.lastTopic}` : "")
                            : "Waiting for MQTT test probe…";
                        return (
                            <Tooltip title={tooltip}>
                                <Box
                                    sx={{
                                        width: 22, height: 22,
                                        marginTop: "10px", marginRight: "10px",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        position: "relative",
                                    }}
                                    aria-label="mqtt-status-indicator"
                                    data-cc-mqtt-probe-count={mqttReceived.probeCount}
                                    data-cc-mqtt-total-count={mqttReceived.totalCount}
                                >
                                    <Box
                                        sx={{
                                            width: 10, height: 10, borderRadius: "50%",
                                            backgroundColor: dotColor,
                                            transition: "transform 220ms ease, box-shadow 220ms ease",
                                            transform: mqttPing ? "scale(1.6)" : "scale(1)",
                                            boxShadow: mqttPing
                                                ? "0 0 0 6px rgba(91,141,239,0.35)"
                                                : "0 0 0 0 rgba(0,0,0,0)",
                                        }}
                                    />
                                </Box>
                            </Tooltip>
                        );
                    })()}
                    {/* THE BELL, RIGHT OF THE PROBE DOT. It re-fetches when notificationSignal moves
                        -- the MQTT push is a nudge and the server remains the only authority on what
                        this user may see. Until Foundation had this, an approver's only way to find
                        work was to go looking for it. */}
                    {sessionContext.valid() && (
                        <div style={{paddingTop: "1px", marginRight: "8px"}}>
                            <NotificationBell refreshSignal={notificationSignal}/>
                        </div>
                    )}
                    {sessionContext.valid() ? (
                        <div style={{width: "45px", paddingTop: "3px"}}><AssistantChat/></div>
                    ) : null}
                    <div style={{width: "45px", paddingTop: "3px"}}>{renderSiteNavigation()}</div>
                    {sessionContext.valid() ? (
                        <div style={{width: "45px", paddingTop: "3px"}}>{renderVisibilityNavigation()}</div>
                    ) : null}
                    <div style={{width: "45px", paddingTop: "1px"}}>{renderAccountNavigation()}</div>
                </Box>
            </div>
        </div>
    )

    function onSwitchAccountClose() {
        setShowSwitchAccount(false)
    }

    return (
        <>
            {showSwitchAccount ? <SwitchAccount/> : null}
            {showChangePassword ? <ChangePasswordDialog onClose={() => setShowChangePassword(false)}/> : null}
            {content}
        </>
    );


    function renderSiteNavigation() {
        const loggedIn = sessionContext.valid();

        const goToSite = (route: string, externalUrl?: string) => {
            if (externalUrl) {
                // Logged in: hand off this app's access token via the shared SSO param so the
                // target app can exchange it for a native session. Logged out: open with no token.
                //
                // THE ACTIVE ACCOUNT AND PERSONA ARE OFFERED, not imposed. The exchange verifies the
                // persona against the list it would itself have offered and refuses when it does not
                // belong, and the target falls back to asking -- so the hint can only save a question,
                // never answer one wrongly. The account half is safe outright: the suite is one database
                // partitioned by realm, so an account USID means the same thing on both sides.
                const accessToken = loggedIn ? sessionContext.getAccessToken() : null;
                window.open(buildSsoHandoffUrl(externalUrl, accessToken, handoffVisibility(sessionContext)), "_blank", "noopener,noreferrer");
            } else if (loggedIn) {
                navigate(route);
            } else {
                navigate("/");
            }
            setMenu(null);
        };

        const siteCard = (icon: React.ReactNode, title: string, description: string, route: string, externalUrl?: string) => (
            <>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <IconButton className={css_buttons.blueIconButton} style={{height: "72px", width: "72px"}} onClick={() => goToSite(route, externalUrl)}>
                        {icon}
                    </IconButton>
                    <div style={{marginLeft: "10px"}}>
                        <Link underline="none" variant="inherit" color="inherit" href="#" onClick={e => {
                            e.preventDefault();
                            goToSite(route, externalUrl);
                        }}><Typography style={{fontSize: "22px", fontWeight: 500, color: "#000000", textAlign: "left"}}>{title}</Typography></Link>
                    </div>
                </div>
                <div style={{marginTop: "6px"}}>
                    <Typography style={{fontSize: "13px", fontWeight: "400", color: Grey5, textAlign: "left"}}>{description}</Typography>
                </div>
            </>
        );

        const iconSx = {color: Blue3, width: "54px", height: "54px"};
        // ADMINISTRATION AND DEVELOPER ARE APPLICATION GRANTS, and the launcher should not offer a
        // door that the other end refuses. Both apps gate every one of their service actions on a
        // privilege -- t6 on `administrator`, the Developer tier on `developer` -- so without the
        // grant the tile leads to a page that loads and then 403s on everything it tries to fetch.
        //
        // UX ONLY. The gate is the server's -- every one of these products refuses at its own
        // door now -- and this stops advertising a refusal.
        //
        // WHICH PRODUCTS ARE OPEN IS THE SERVER'S ANSWER TOO, settled at login from the privileges
        // the person's roles grant (cres/utils/products.py). Deciding it here would mean a second
        // copy of "which privileges belong to which product" in the browser, and the copy that
        // drifted would be the one choosing what people can see. An absent list -- a session that
        // predates this -- shows everything rather than emptying the launcher.
        const apps: React.ReactNode[] = [
            ...(hasProduct("administration")
                ? [siteCard(<SettingsOutlined sx={iconSx}/>, "Administration", "Manage organizations, positions, roles, users, groups, document types, and data domains for your account.", "/administration", process.env.REACT_APP_ADMINISTRATION_URL || "https://admin.cres-intelligence.io")]
                : []),
            siteCard(<MedicalServicesOutlined sx={iconSx}/>, "Clinical Trials", "Plan, execute, and report on clinical studies — protocols, sites, participants, and outcomes.", "/clinical-trials"),
            ...(hasProduct("dataCatalog")
                ? [siteCard(<DatasetOutlined sx={iconSx}/>, "Data Catalog", "Discover, classify, and govern data assets across your organization.", "/data-catalog", process.env.REACT_APP_DATA_CATALOG_URL || "https://dc.cres-intelligence.io")]
                : []),
            ...(hasProduct("developer")
                ? [siteCard(<CodeOutlined sx={iconSx}/>, "Developer", "API explorer, SDKs, and documentation for building integrations.", "/developer", process.env.REACT_APP_DEVELOPER_URL || "https://developer.cres-intelligence.io")]
                : []),
            // GATED ON `docs`, like every other product tile: the launcher must not offer a door
            // the other end refuses. The server settles which products are open at login
            // (cres/utils/products.py) -- any privilege over documents opens Docs, which is how a
            // document-control clerk reaches it with what they already hold, and how an external
            // reviewer holding only `document:author` gets a launcher with Docs and nothing else.
            ...(hasProduct("docs")
                ? [siteCard(<ArticleOutlined sx={iconSx}/>, "ParkourAI Documents", "Author and review the text of controlled documents \u2014 collaboratively, with suggestions and approvals.", "/documents", process.env.REACT_APP_DOCS_URL || "https://docs.cres-intelligence.io")]
                : []),
            ...(hasProduct("trace")
                ? [siteCard(<TraceIcon sx={iconSx}/>, "ParkourAI Trace", "Requirements, risks, tests and releases of regulated software, linked into one traceable record.", "/", process.env.REACT_APP_TRACE_URL || "https://trace.cres-intelligence.io")]
                : []),
            // GATED, because the launcher must not offer a door the other end refuses. Every
            // Reporting service action requires `reporting`; without the grant this tile leads to
            // an app that loads and then 403s on everything it fetches. Same reasoning, and the
            // same shape, as the Administration and Developer tiles above.
            ...(hasProduct("reporting")
                ? [siteCard(<InsightsOutlined sx={iconSx}/>, "Reporting", "Query your own records — including the answers on your forms — and build analytical views over them.", "/reporting", process.env.REACT_APP_REPORTING_URL || "https://reports.cres-intelligence.io")]
                : []),
            // GATED ON `sbom` (2026-11-02), like every other product tile: SBOM is now described in products.py, and its
            // sign-in refuses a person with no SBOM grant, so the launcher must not offer them its door.
            ...(hasProduct("sbom")
                ? [siteCard(<AccountTreeOutlined sx={iconSx}/>, "SBOM", "Software Bill of Materials — manage component inventories and licenses.", "/sbom", process.env.REACT_APP_SBOM_URL || "https://sbom.cres-intelligence.io")]
                : []),
            siteCard(<VerifiedOutlined sx={iconSx}/>, "Trace", "AI-native compliance and traceability for regulated software — auto-links requirements, risks, code, and tests for FDA, ISO 13485, EU MDR, and more.", "/trace"),
        ];

        return (
            <div>
                <Tooltip title="Sites Portfolio" placement="bottom">
                    <IconButton className={css_self.NavMenuButton} style={{marginTop: "-1px"}} onClick={(e) => setMenu({id: "sites", target: e.currentTarget})}>
                        <Language />
                    </IconButton>
                </Tooltip>
                {menu?.id === "sites" ? (
                    <Popover anchorEl={menu.target}
                             anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                             transformOrigin={{vertical: -15, horizontal: "left"}}
                             open={true}
                             onClose={() => setMenu(null)}
                             slotProps={{
                                 transition: {
                                     onExited: () => setMenu(null),
                                 }
                             }}
                    >
                        <Box sx={{p: 2, bgcolor: "background.paper"}}>
                            <div style={{minWidth: "320px", maxHeight: "80vh", overflowY: "auto", display: "flex", flexDirection: "column"}}>
                                {apps.map((card, idx) => (
                                    <div key={idx} style={{display: "flex", flexDirection: "column", justifyContent: "flex-start", marginBottom: "10px", border: "1px solid #EDEFF3", borderRadius: "10px", padding: "15px", boxSizing: "border-box"}}>
                                        {card}
                                    </div>
                                ))}
                            </div>
                        </Box>
                    </Popover>
                ) : null}
            </div>
        );
    }

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    async function refresh() {
        // @ts-ignore
        axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t1/v1/authenticate",
            json: true,
            data: {
                "X-Cres-RefreshToken": sessionContext.getRefreshToken(),
            },
        }).then(response => {
            let visibilityMode, visibilityValue
            if (response.data["Account"]["Positions"].length > 0) {
                visibilityMode = "Position";
                visibilityValue = response.data["Account"]["Positions"][0].USID;
            } else if (response.data["Account"]["UserGroups"].length > 0) {
                visibilityMode = "UserGroup";
                visibilityValue = response.data["Account"]["UserGroups"][0].USID;
            } else if (response.data["Account"]["WorkGroups"].length > 0) {
                visibilityMode = "WorkGroup";
                visibilityValue = response.data["Account"]["WorkGroup"][0].USID;
            }

            sessionContext.setActiveVisibility(visibilityMode!, visibilityValue)
            sessionContext.setIdentityToken(response.data["IdentityToken"])
            sessionContext.setSessionUSID(response.data["Session"])
            sessionContext.setAccessToken(response.data["AccessToken"])
            sessionContext.setRefreshToken(response.data["RefreshToken"])
            sessionContext.setAccountName(response.data["Account"]["AccountName"])
            sessionContext.setAccountUserUSID(response.data["Account"]["AccountUserUSID"])
            sessionContext.setAccount(response.data["Account"])
            sessionContext.setRoles(response.data["Roles"])
            sessionContext.setPrivileges(response.data["Privileges"])
            sessionContext.setProducts(response.data["Products"] || [])
            sessionContext.setPrivilegeConstraints(response.data["PrivilegeConstraints"])
            sessionContext.setTenants(response.data["Tenants"])
            sessionContext.setShowLoginDialog(false)
            sessionContext.setPickValues(response.data["PickValues"])

            window.location.href="/";
        }).catch(() => {
            EventBus.error.emit("show-system-error");
        });
    }

    function renderAccountNavigation() {
        let accountMarkup = (
            <div>
                <IconButton className={css_self.NavMenuButton} onClick={() => {
                    if (sessionContext) { // @ts-ignore
                        sessionContext.setShowLoginDialog(true);
                    }
                    setShowLoginDialog(true);
                }}>
                    <PermIdentity/>
                </IconButton>
            </div>
        )
        if (sessionContext.valid()) {
            accountMarkup = (
                <Button className={css_self.NavMenuButton} variant="text" onClick={(e) => setMenu({id: "account", target: e.currentTarget})}>
                    <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 35, height: 35}}>{stringAvatar(sessionContext.getName())}</Avatar>
                </Button>
            )
        }

        return (
            <div>
                {showLoginDialog ? <Login2/> : null}
                {accountMarkup}
                {menu?.id === "account" ? (
                    <Menu
                        anchorEl={menu.target}
                        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                        transformOrigin={{vertical: -16, horizontal: "center"}}
                        open={true}
                        onClose={() => setMenu(null)}
                        slotProps={{
                            list: {
                                ...{"data-cc-component": "NavMenu"},
                                disablePadding: true,
                                style: {"minWidth": "200px"},
                            },

                            transition: {
                                onExited: () => setMenu(null),
                            }
                        }}>
                        <MenuItem key={"account"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Account: <b>{sessionContext.getAccountName()}</b></Typography>
                        </MenuItem>
                        <MenuItem key={"name"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Hello, <b>{sessionContext.getName()}</b></Typography>
                        </MenuItem>
                        <MenuItem divider key={"help"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/help");
                        }}>
                            <HelpOutlineOutlined style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Help</Typography>
                        </MenuItem>
                        <MenuItem divider key={"settings"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/mycres");
                        }}>
                            <Settings style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>My Parkour</Typography>
                        </MenuItem>
                        <MenuItem divider onClick={() => { setMenu(null); setShowChangePassword(true); }}>
                            <LockResetOutlined style={{color: Grey6}} />
                            Change password
                        </MenuItem>
                        <MenuItem divider key={"switchCompany"} className={css_self.Standard} onClick={() => {
                            setShowSwitchAccount(true);
                            setMenu(null);
                        }}>
                            <SwitchAccountIcon style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Switch Account</Typography>
                        </MenuItem>
                        <MenuItem divider key={"refresh"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            refresh();
                        }}>
                            <Sync style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Refresh</Typography>
                        </MenuItem>
                        <MenuItem divider key={"logout"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/logout");
                        }}>
                            <Logout style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Log out</Typography>
                        </MenuItem>
                    </Menu>
                ) : null}
            </div>
        );
    }

    function renderVisibilityNavigation() {
        let account: Account = sessionContext.getAccount()!;

        return (
            <>
                <Tooltip title="Personas" placement="bottom">
                    <IconButton className={css_self.NavMenuButton} style={{marginTop: "-1px"}} onClick={(e) => setMenu({id: "visibility", target: e.currentTarget})}>
                        <SyncAlt />
                    </IconButton>
                </Tooltip>
                {menu?.id === "visibility" ? (
                    <Menu
                        anchorEl={menu?.target}
                        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                        transformOrigin={{vertical: -17, horizontal: "right"}}
                        open={true}
                        onClose={() => setMenu(null)}
                        slotProps={{
                            list: {
                                ...{"data-cc-component": "NavMenu"},
                                disablePadding: true,
                                style: {"minWidth": "300px"},
                            },

                            transition: {
                                onExited: () => setMenu(null),
                            }
                        }}>
                        {account.Positions.length > 0 ? (
                            <>
                                <MenuItem key="position-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>Positions</Typography>
                                    </div>
                                </MenuItem>
                                {buildPositionTree(account.Positions, account.PositionAncestors ?? []).map(row => (
                                    <MenuItem key={row.node.USID} className={css_self.Standard}
                                              // Stretch, so the guide columns are full row height and
                                              // their borders meet the rows above and below.
                                              sx={{alignItems: "stretch",
                                                   paddingTop: `${ROW_PADDING}px`,
                                                   paddingBottom: `${ROW_PADDING}px`}}
                                              disabled={!row.selectable}
                                              onClick={row.selectable ? () => {
                                                  setMenu(null);
                                                  sessionContext.setActiveVisibility("Position", row.node.USID);
                                                  EventBus.visibility.emit("change-visibility", "Position");
                                              } : undefined}>&emsp;&emsp;
                                        <PositionTreeGuides row={row} />
                                        <SupervisorAccount style={{color: row.selectable ? Grey17 : Grey6,
                                                                   alignSelf: "center"}} />
                                        <div style={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", fontWeight: "400",
                                                                color: row.selectable ? Grey17 : Grey6}}>
                                                {row.node.Name}
                                            </Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                        {account.UserGroups.length > 0 ? (
                            <>
                                <MenuItem key="userGroup-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>User Groups</Typography>
                                    </div>
                                </MenuItem>
                                {account.UserGroups.map(userGroup => (
                                    <MenuItem key={userGroup["USID"]} className={css_self.Standard} onClick={() => {
                                        setMenu(null);
                                        sessionContext.setActiveVisibility("User Group", userGroup.USID);
                                        EventBus.visibility.emit("change-visibility", "User Group");
                                    }}>&emsp;&emsp;
                                        <ThumbUp style={{color: Grey17}} />
                                        <div style={{display: "block", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>{userGroup.Name}</Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                        {account.WorkGroups.length > 0 ? (
                            <>
                                <MenuItem key="workgroup-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <div>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>Work Groups</Typography>
                                        </div>
                                    </div>
                                </MenuItem>
                                {account.WorkGroups.map(workgroup => (
                                    <MenuItem key={workgroup.USID} className={css_self.Standard} onClick={() => {
                                        setMenu(null);
                                        sessionContext.setActiveVisibility("Work Group", workgroup.USID);
                                        EventBus.visibility.emit("change-visibility", "Work Group");
                                    }}>&emsp;&emsp;
                                        <WorkOutline style={{color: Grey17}} />
                                        <div style={{display: "block", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>{workgroup.Name}</Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                    </Menu>
                ) : null}
            </>
        );
    }


}
